import { Action } from '../../../../redux/redux.types';
import { APPLICATION_PERMISSION_ACTION_NAMES } from './application-permission-card.actions';
import { ApplicationPermissionState } from './application-permission-card.types';
import { PERMISSIONS_ACTION_NAMES } from '../../../../redux/permissions/permissions.actions';

const defaultState: ApplicationPermissionState = {
  isInfoSidebarOpen: false,
  selectedPermissionId: '',
};

export const applicationPermission = (
  state: ApplicationPermissionState = defaultState,
  { type, payload }: Action,
): ApplicationPermissionState => {
  switch (type) {
    case APPLICATION_PERMISSION_ACTION_NAMES.SHOW_INFO_SIDEBAR: {
      return {
        ...state,
        isInfoSidebarOpen: true,
        selectedPermissionId: payload,
      };
    }

    case PERMISSIONS_ACTION_NAMES.CREATE_PERMISSION_SUCCESS:
    case APPLICATION_PERMISSION_ACTION_NAMES.HIDE_INFO_SIDEBAR:
      return {
        ...state,
        isInfoSidebarOpen: false,
        selectedPermissionId: '',
      };

    default: {
      return state;
    }
  }
};
